class TestimonialsSlider {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('.customer-testimonials__slides');
    this.slides = Array.from(this.track.children);
    this.prevButton = root.querySelector('.customer-testimonials__nav--prev');
    this.nextButton = root.querySelector('.customer-testimonials__nav--next');
    this.desktopCount = parseInt(root.dataset.slideCountDesktop, 10) || 3;
    this.mobileCount = parseInt(root.dataset.slideCountMobile, 10) || 1;
    this.autoplayEnabled = root.dataset.autoplay === 'true';
    this.intervalTime = parseInt(root.dataset.interval, 10) || 6000;
    this.currentIndex = 0;
    this.resizeHandler = this.handleResize.bind(this);
    this.boundPrev = () => this.move(-1);
    this.boundNext = () => this.move(1);

    this.setSizes();
    window.addEventListener('resize', this.resizeHandler);
    this.prevButton?.addEventListener('click', this.boundPrev);
    this.nextButton?.addEventListener('click', this.boundNext);
    if (this.autoplayEnabled) {
      this.startAutoplay();
      this.root.addEventListener('mouseenter', () => this.stopAutoplay());
      this.root.addEventListener('mouseleave', () => this.startAutoplay());
    }
    this.updateAccessibility();
  }

  get slidesPerView() {
    return window.innerWidth < 750 ? this.mobileCount : this.desktopCount;
  }

  setSizes() {
    const perView = Math.max(1, this.slidesPerView);
    const widthPercent = 100 / perView;
    this.slides.forEach((slide) => {
      slide.style.width = `${widthPercent}%`;
    });
    this.maxIndex = Math.max(0, this.slides.length - perView);
    if (this.currentIndex > this.maxIndex) {
      this.currentIndex = this.maxIndex;
    }
    this.updateTransform();
    this.updateControlsState();
  }

  handleResize() {
    this.setSizes();
  }

  move(direction) {
    if (this.maxIndex === 0) return;
    this.currentIndex += direction;
    if (this.currentIndex < 0) {
      this.currentIndex = this.maxIndex;
    } else if (this.currentIndex > this.maxIndex) {
      this.currentIndex = 0;
    }
    this.updateTransform();
    this.updateControlsState();
    if (this.autoplayEnabled) {
      this.restartAutoplay();
    }
  }

  updateTransform() {
    const perView = Math.max(1, this.slidesPerView);
    const offset = (100 / perView) * this.currentIndex;
    this.track.style.transform = `translateX(-${offset}%)`;
  }

  updateControlsState() {
    const disabled = this.maxIndex === 0;
    if (this.prevButton) this.prevButton.disabled = disabled;
    if (this.nextButton) this.nextButton.disabled = disabled;
  }

  startAutoplay() {
    if (this.maxIndex === 0) return;
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => this.move(1), this.intervalTime);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  restartAutoplay() {
    if (!this.autoplayEnabled) return;
    this.stopAutoplay();
    this.startAutoplay();
  }

  updateAccessibility() {
    this.prevButton?.setAttribute('aria-controls', this.track.id || '');
    this.nextButton?.setAttribute('aria-controls', this.track.id || '');
  }
}

function initTestimonialsSliders() {
  const sliders = document.querySelectorAll('.customer-testimonials__slider');
  sliders.forEach((slider) => {
    if (slider._testimonialsSlider) return;
    slider._testimonialsSlider = new TestimonialsSlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', initTestimonialsSliders);

document.addEventListener('shopify:section:load', initTestimonialsSliders);

